import type React from 'react';

import { RouterProvider, TabList, Tabs } from '@change/ds-core-ui';

import { usePageHeading } from './hooks/usePageHeading';

export const PageHeading: React.FC = () => {
	const {
		data: { tabItems, guides },
	} = usePageHeading();

	return (
		<div className="container mt-2 px-0">
			{/* RouterProvider overrides app-level SPA navigation so tab switches are full page loads.
				News and guides share the same path (/l/:country) and only differ by ?category=guides,
				so client-side navigation would show a loading indicator unnecessarily. */}
			<RouterProvider
				navigate={(href) => {
					window.location.assign(href);
				}}
			>
				<Tabs selectedKey={guides ? 'guides' : 'news'}>
					<TabList items={tabItems} />
				</Tabs>
			</RouterProvider>
		</div>
	);
};
